export default __webpack_public_path__ + "static/media/killjoy_new.22ee0262.png";